<template>
  <div class="search-results-mobile">
    <section class="search-results-module has-bg-gray-10">
      <div class="container">

        <template v-for="(item, index) in tabs">
          <button
              class="has-font-weight-bold"
              :key="`tab-${index}`"
              :class="{'tab__inactive': !item.isActive, 'clicked': item.isActive}"
              @click="setActive(index, item.name)">
            {{item.name}}   
          </button>
        </template>
      </div>
    </section>
  </div>

</template>

<script>    
    export default {
        name: "SearchFilter",
        data: function () {
            return {
                tabs: []
            }
        },
        computed: {
            results: function () {
                return this.$store.state.searchResults;
            }
        },
        watch: {
            results: function () {
                const categoryMap = {};
                this.tabs.splice(0);

                if (this.results != null) {
                    this.results.length > 0 && this.tabs.push({
                        name: 'ALL', isActive: true
                    });
                    this.results.forEach(el => {
                        if (el.category !== "") {
                            categoryMap[el.category] = 1;
                        }
                    });
                }
                Object.keys(categoryMap).forEach(cat => this.tabs.push({ name: cat, isActive: false }));
                this.setActive(0, 'ALL');
            }
        },
        methods: {
            setActive(index, categoryName) {
                for (let i = 0; i < this.tabs.length; i++) {
                    this.tabs[i].isActive = i === index;
                }

                let filtered = this.results != null ? this.results.filter(e => {
                    let ok = false;
                    switch (categoryName) {
                        case 'ALL':
                            ok = true;
                            break;
                        default:
                            if (e.category === categoryName) {
                                ok = true;
                            }
                    }
                    return ok;
                }) : [];
                this.$store.commit('setFilteredResults', filtered);
            }
        }
    }
</script>

<style scoped>
button:after {
  content: '';
  display: block;
  height: 2px;
  width: 0;
  background: transparent;
  transition: width .5s ease, background-color .5s ease;
}
button.clicked:after,
button:hover:after,
button:focus:after,
button:focus-visible:after {
  width: 100%;
  background: #009dd6;
}
button:focus,
button:focus-visible {
    outline-color: transparent;
    border-color: transparent;
    box-shadow: none;
    outline: none;    
}
.tab__inactive{
  cursor: pointer;
  color: #565656;
  transition: all 0.5s ease;
}
.tab__inactive:hover{
  color: black;
  transition: all 0.5s ease;
}
.container{
  display: flex;
  justify-content: center;
}
button {
  display: inline;
  margin: 16px 20px 8px 0;
}

@media screen and (max-width: 992px) {
  button {
    white-space: nowrap;
  }
  .search-results-module{
    overflow-x: scroll;
    margin-right: 3vw;
    margin-left: 3vw;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */    
  }
  .search-results-module::-webkit-scrollbar {
    display: none;
  }  
  .search-results-mobile{
    background-color: #F2F2F2;
  }
  .container{
    justify-content: flex-start !important;
  }
}
</style>